import localhost from "apis/localhost";
import { JSON_CONTENT_TYPE } from "constants/app";
import { showErrorModal } from "slices/app/actions/error";
import { addToJobQueue, removeFromJobQueue } from "slices/app/appSlice";
import {
  getFormDataForNewOpportunity,
  getOpportunityUrl,
} from "slices/opportunity/opportunities/actions/helpers";
import { setShowEditModal } from "slices/opportunity/opportunities/opportunitiesSlice";
import {
  setIsLoading,
  setOpportunity,
} from "slices/opportunity/summary/summarySlice";
import { getErrorMessage } from "utils";

const HEADERS = {
  headers: {
    "Content-Type": JSON_CONTENT_TYPE,
  },
};

export const fetchOpportunityByOpportunityId =
  (opportunityId) => async (dispatch) => {
    dispatch(setIsLoading(true));
    const url = `/nextgen/entity/${opportunityId}`;

    try {
      const rsp = await localhost.get(url, HEADERS);
      const data = rsp?.data || {};
      dispatch(setOpportunity(data));
      dispatch(setIsLoading(false));
      return data;
    } catch (err) {
      if (/tracked opportunity not found/i.test(getErrorMessage(err))) {
        return { notFound: true };
      }
      return false;
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const fetchOpportunityBySolicitationId =
  (solicitationId) => async (dispatch) => {
    dispatch(setIsLoading(true));
    const url = `/nextgen/opportunitySearch/samgov?solNumber=${solicitationId}`;

    try {
      const rsp = await localhost.get(url, HEADERS);
      const data = rsp?.data || {};
      dispatch(setOpportunity(data));
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const fetchOpportunityByOcidAndSourceCode =
  (ocid, sourceCode) => async (dispatch) => {
    dispatch(setIsLoading(true));
    const url = `/nextgen/opportunitySearch/ocds/${sourceCode}/${ocid}`;

    try {
      const rsp = await localhost.get(url, HEADERS);
      const data = rsp?.data || {};
      dispatch(setOpportunity(data));
    } catch (err) {
      console.error(err);
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const fetchEBuyOpportunityByRequestId =
  (requestId, rowData) => async (dispatch) => {
    dispatch(setIsLoading(true));
    const url = `/nextgen/opportunitySearch/ebuy/${requestId}`;

    try {
      const rsp = await localhost.get(url, HEADERS);
      const data = rsp?.data || {};
      dispatch(setOpportunity(data));
    } catch (err) {
      console.error(err);
      if (rowData) {
        dispatch(setOpportunity(rowData));
      }
    } finally {
      dispatch(setIsLoading(false));
    }
  };

export const editOpportunity = (data, oppType) => async (dispatch) => {
  dispatch(addToJobQueue("editOpportunity"));

  const url = getOpportunityUrl(oppType);
  const formData = getFormDataForNewOpportunity(data, oppType);

  try {
    await localhost.put(url, formData, HEADERS);
    dispatch(setShowEditModal(false));
    dispatch(fetchOpportunityByOpportunityId(data.id));
  } catch (error) {
    dispatch(showErrorModal(error));
  } finally {
    dispatch(removeFromJobQueue("editOpportunity"));
  }
};

export const editSamGovOpportunityFields = (data) => async (dispatch) => {
  dispatch(addToJobQueue("editSamGovOpportunity"));

  try {
    await localhost.put("/nextgen/opportunity/sam-gov", data, HEADERS);
    dispatch(setShowEditModal(false));
    dispatch(fetchOpportunityByOpportunityId(data.id));
  } catch (error) {
    dispatch(showErrorModal(error));
  } finally {
    dispatch(removeFromJobQueue("editSamGovOpportunity"));
  }
};

export const editFindATenderOpportunityFields = (data) => async (dispatch) => {
  dispatch(addToJobQueue("editFindATenderOpportunity"));

  try {
    await localhost.put("/nextgen/opportunity/ocds", data, HEADERS);
    dispatch(setShowEditModal(false));
    dispatch(fetchOpportunityByOpportunityId(data.id));
  } catch (error) {
    dispatch(showErrorModal(error));
  } finally {
    dispatch(removeFromJobQueue("editFindATenderOpportunity"));
  }
};

export const editEBuyOpportunityFromTracked = (data) => async (dispatch) => {
  dispatch(addToJobQueue("editEBuyOpportunity"));
  const { opportunityId, ...payload } = data;

  try {
    await localhost.put(
      "/nextgen/opportunity/ebuy",
      { ...payload, id: opportunityId },
      HEADERS
    );
    dispatch(setShowEditModal(false));
    dispatch(fetchOpportunityByOpportunityId(opportunityId));
  } catch (error) {
    dispatch(showErrorModal(error));
  } finally {
    dispatch(removeFromJobQueue("editEBuyOpportunity"));
  }
};
